module.exports = __webpack_public_path__ + "static/media/DSC_0041.0ee4a85f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0041.jpg
// module id = 622
// module chunks = 0